// Copyright (c) 2025 by Audere

import { useGetConversationForQCQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { useSelector } from "react-redux";
import { useCurrentUser } from "./useCurrentUser";

export const useConversationForQC = (conversation_uid: string, labeling_type: string) => {
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);
  const { isMonitor } = useCurrentUser();
  const {
    data: conversation,
    isLoading,
    isFetching,
    error,
  } = useGetConversationForQCQuery(
    {
      group: userGroupRole.group,
      conversation_uid,
      labeling_type,
      message_cursor: null,
      limit: 1000,
    },
    {
      pollingInterval: 0,
      skipPollingIfUnfocused: true,
      refetchOnFocus: false,
      refetchOnReconnect: true,
      skip: !conversation_uid || isMonitor,
    }
  );

  return { conversation, isLoading, isFetching, error };
};
